var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagStoresOfferTips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 1.5C2.96957 1.5 2.46086 1.71071 2.08579 2.08579C1.71071 2.46086 1.5 2.96957 1.5 3.5V6.37867C1.50011 6.90906 1.7109 7.41768 2.086 7.79267L8.47267 14.18C9.086 14.7933 10.066 14.9707 10.838 14.4653C12.2836 13.5187 13.5184 12.2841 14.4653 10.8387C14.9707 10.0653 14.7933 9.086 14.18 8.47333L7.79333 2.086C7.60758 1.90019 7.38704 1.7528 7.1443 1.65225C6.90157 1.5517 6.6414 1.49997 6.37867 1.5H3.5ZM4.25 5C4.44891 5 4.63968 4.92098 4.78033 4.78033C4.92098 4.63968 5 4.44891 5 4.25C5 4.05109 4.92098 3.86032 4.78033 3.71967C4.63968 3.57902 4.44891 3.5 4.25 3.5C4.05109 3.5 3.86032 3.57902 3.71967 3.71967C3.57902 3.86032 3.5 4.05109 3.5 4.25C3.5 4.44891 3.57902 4.63968 3.71967 4.78033C3.86032 4.92098 4.05109 5 4.25 5Z",
    fill: "#1C7A9E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagStoresOfferTips);
export default __webpack_public_path__ + "static/media/tag_stores-offer-tips.f0e6fb7efb03e0a98a723602f986ecc6.svg";
export { ForwardRef as ReactComponent };